import { RecaptchaVersion } from './recaptcha-constants.js';
/**
 * This functions executes the reCAPTCHA check programmatically. Used if the reCAPTCHA version is V3.
 * @param options reCAPTCHA v3 check options
 */
const executeGrecaptcha = (options) => {
    const { onExpireCallback, onLoadCallback, siteKey, version } = options;
    if (!window.grecaptcha || version !== RecaptchaVersion.V3) {
        return;
    }
    /**
     * Using try catch because execute method does not return the real promise, it returns an PromiseLike that has no catch option
     */
    try {
        void window.grecaptcha.execute(siteKey, { action: 'verify' })
            .then((response) => onLoadCallback(response));
    }
    catch (error) {
        onExpireCallback();
    }
};
export { executeGrecaptcha, };
//# sourceMappingURL=recaptcha-utils.js.map